import { eventInvalidations } from "@circle-react/lib/queries/events";

export const useInvalidateEventQueries =
  () =>
  ({ shouldInvalidateAllEvents = false } = {}) => {
    void eventInvalidations.postBackedSurfaces();

    if (shouldInvalidateAllEvents) {
      void eventInvalidations.all();
    }
  };
